import { render, staticRenderFns } from "./setprice.vue?vue&type=template&id=6a1f708a&"
import script from "./setprice.vue?vue&type=script&lang=js&"
export * from "./setprice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports